import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import DeleteCartHook from "../../hook/cart/DeleteCartHook";
import { ToastContainer } from "react-toastify";
import ApplyCouponHook from "../../hook/cart/ApplyCouponHook";
import notify from "../../hook/useNotification";
import { BiLeftArrowCircle } from "react-icons/bi";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { getOneUser } from "../../redux/actions/usersActions";
import { useDispatch, useSelector } from "react-redux";
import LoadingBar from "react-top-loading-bar";
import Confetti from "react-confetti";

const CartCheckout = ({
  totalPrice,
  totalPriceAfterDiscount,
  couponNameAfterApplay,
  cartItems,
  vendorId,
  totalShippingCost,
  loginCart=true
}) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const [handleDeletCart] = DeleteCartHook();
  const [
    couponName,
    onChangeCoupon,
    handleSubmitCoupon,
    vatValue,
    settingsRes,
    res,
    couponId,
    loading,
  ] = ApplyCouponHook();

  let calcVatValue =
    totalPrice - (totalPrice * 100) / (Number(vatValue) + 100) || 0;
  const currencytype =
    Cookies.get("i18next") === "ar"
      ? settingsRes.data?.defaultCurrancy.ar
      : settingsRes.data?.defaultCurrancy.en;

  const [userData, setUserData] = useState();
  const [userLoading, setuserLoading] = useState(true);
  const [shippingCost, setShippingCost] = useState(0);
  const ref = useRef(null);

  var user = "";
  if (localStorage.getItem("user") != null) {
    user = JSON.parse(localStorage.getItem("user"));
  }

  console.log("cartItems", cartItems);

  const [showConfettiState, setShowConfettiState] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem('showConfetti') === 'true') {
      setShowConfettiState(true);
      sessionStorage.removeItem('showConfetti');
      setTimeout(() => {
        setShowConfettiState(false);
      }, 5000);
    }
  }, []);

  useEffect(() => {
    ref.current.continuousStart();

    const get = async () => {
      setuserLoading(true);
      // console.log('vendorId');
      // console.log(vendorId);
      if (vendorId) await dispatch(getOneUser(vendorId._id));
      setuserLoading(false);
    };
    get();
  }, [vendorId]);
  const oneUser = useSelector((state) => state.usersReducers.oneUser);

  useEffect(() => {
    if (userLoading === false) {
      if (
        cartItems.reduce((a, b) => a + b.product?.weight * b.quantity, 0) /
          1000 <=
        parseInt(oneUser?.shipping?.wieghtNumber || 0)
      ) {
        setShippingCost(parseInt(oneUser?.shipping?.wieghtCost));
      } else {
        const productWeightSubtractShippingWeight =
          cartItems.reduce((a, b) => a + b.product?.weight * b.quantity, 0) /
            1000 -
          parseInt(oneUser?.shipping?.wieghtNumber);
        const cost =
          productWeightSubtractShippingWeight *
            parseInt(oneUser?.shipping?.wieghtExtraCost) +
          parseInt(oneUser?.shipping?.wieghtCost);

        // console.log('cost')
        setShippingCost(cost.toFixed(2));
      }
      ref.current.complete();
    }
  }, [userLoading]);

  const navigate = useNavigate();

  useEffect(() => {
    if (couponNameAfterApplay) {
      onChangeCoupon(couponNameAfterApplay);
    }
  }, [couponNameAfterApplay]);

  const handleCheckout = () => {
  
    if (!user){
       notify(t("Log in first"), "warn");

       setTimeout(() => {
        navigate("/login");  
       },2000);

       return;
    } 

    if (cartItems.length >= 1) {
      let totalCartPrice = cartItems[0]?.couponId?._id
        ? totalPriceAfterDiscount
        : totalPrice;

      console.log("totalCartPrice", totalCartPrice);

      navigate("/order/paymethoud", {
        state: { shippingCost, totalCartPrice },
      });
    } else {
      notify(t("Please add products to the cart"), "warn");
    }
  };

  console.log("totalPrice", totalPrice);
  console.log("totalPriceAfterDiscount", totalPriceAfterDiscount);
  console.log('totalShippingCost',totalShippingCost);

  return (
    <div className="cart-summary-card position-sticky" style={{ top: "20px" }}>
      <Helmet>
        <title>
          {` ${t("shopping cart")} -  ${
            Cookies.get("i18next") === "ar"
              ? settingsRes?.data?.titleAr || ""
              : settingsRes?.data?.titleEn || ""
          }`}{" "}
        </title>
      </Helmet>

      {showConfettiState && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 99999, pointerEvents: 'none' }}>
          <Confetti 
            width={window.innerWidth} 
            height={window.innerHeight} 
            recycle={false} 
            numberOfPieces={600} 
            gravity={0.15} 
            initialVelocityY={20}
          />
        </div>
      )}
      <LoadingBar
        color={settingsRes?.data?.primaryColor || "#3182ce"}
        ref={ref}
        shadow={true}
        height={4}
      />

      <div className="cart-summary-title">{t("Order Summary")}</div>

      {/* Subtotal */}
      <div className="cart-summary-row">
        <span>{t("Subtotal")}</span>
        <span>{totalPrice} {currencytype}</span>
      </div>

      {/* Discount */}
      {cartItems[0]?.couponId?._id && (
        <div className="cart-summary-row text-success">
          <span>{t("Discount")} ({couponNameAfterApplay})</span>
          <span>-{(totalPrice - totalPriceAfterDiscount).toFixed(2)} {currencytype}</span>
        </div>
      )}

      {/* VAT */}
      {settingsRes?.data?.vatValue && settingsRes?.data?.vatValue !== "0" && (
         <div className="cart-summary-row text-muted">
           <span>{t("value added tax")} ({vatValue}%)</span>
           <span>{calcVatValue.toFixed(2)} {currencytype}</span>
         </div>
      )}

      {/* Weight */}
      <div className="cart-summary-row text-muted">
        <span>{t("weight")}</span>
        <span>
          {cartItems.reduce((a, b) => a + b.product?.weight * b.quantity, 0) / 1000} {t("Kg")}
        </span>
      </div>

      {/* Shipping */}
      {loginCart && (
        <div className="cart-summary-row">
          <span>{t("Shipping charges")}</span>
          <span>{totalShippingCost} {currencytype}</span>
        </div>
      )}

      {/* Total */}
      <div className="cart-summary-total">
        <span>{t("Total")}</span>
        <span>
          {totalPriceAfterDiscount >= 1
            ? (Number(totalPriceAfterDiscount) + Number(totalShippingCost)).toFixed(2)
            : (Number(totalPrice) + Number(totalShippingCost)).toFixed(2)}{" "}
          {currencytype}
        </span>
      </div>

      {/* Coupon Form */}
      <div className="mt-4">
        <label className="form-label text-muted small fw-bold mb-2">{t("discount code")}</label>
        <div className="input-group input-group-sm">
          <input
            className="form-control cart-coupon-input"
            value={couponName}
            onChange={(e) => onChangeCoupon(e.target.value)}
            placeholder={t("discount code")}
          />
          <Button 
            className="cart-coupon-btn text-white border-0 btn-sm"
            style={{
              backgroundColor: settingsRes?.data?.cartColor || settingsRes?.data?.primaryColor || "#3182ce"
            }}
            onClick={handleSubmitCoupon}
            disabled={loading}
          >
            {loading ? <Spinner animation="border" size="sm" /> : t("apply")}
          </Button>
        </div>
      </div>

      <div className="d-flex flex-column gap-2 mt-4">
        <button
          onClick={handleCheckout}
          className="cart-checkout-btn border-0 text-white m-0"
          style={{
            backgroundColor: settingsRes?.data?.cartColor || settingsRes?.data?.primaryColor || "#3182ce"
          }}
        >
          {t("Checkout")}
        </button>

        <button
          onClick={() => navigate("/")}
          className="btn btn-light btn-sm w-100 fw-bold border py-2"
        >
          {t("Continue shopping")}
        </button>

        <Button
          onClick={handleDeletCart}
          variant="outline-danger"
          size="sm"
          className="w-100 fw-bold py-2"
        >
          <i className="fa-solid fa-trash-can me-2" />
          {t("delete cart")}
        </Button>
      </div>

      {settingsRes?.data?.couponText && (
        <div className="alert alert-info mt-4 text-center mb-0 border-0 bg-info bg-opacity-10 text-info">
          <i className="fa-solid fa-circle-info me-2"></i>
          {settingsRes?.data?.couponText}
        </div>
      )}

      <ToastContainer rtl />
    </div>
  );
};

export default CartCheckout;
